import { Resource } from 'src_common/common/mobx-utils/Resource';
import { SessionDataType } from 'src/domains/casino/types/types';
import { Session } from 'src_common/sdk/session';
import { openapiProvidersCustomerGetSessionRequest } from 'src/domains/casino/api/generated/providers/openapi_providers_customer_get_session';
import { GameDataState } from 'src/domains/casino/state/AppCasino/game-modal/GameData.state';

export const getSessionData = (session: Session, gameDataState: GameDataState): Resource<SessionDataType> => {
    const { launchId, isDemo, mobile, isMini } = gameDataState;
    const provider = gameDataState.provider === 'sg-digital' ? 'sg' : gameDataState.provider;

    if (provider === 'pragmatic') {
        const promise = session.call(openapiProvidersCustomerGetSessionRequest, {
            provider: 'new-pragmatic',
            requestBody: {
                launch_game_id: launchId,
                demo_mode: isDemo,
                mini_mode: isMini,
                mobile,
            },
        });

        return new Resource(async (): Promise<SessionDataType> => promise);
    }

    const promise = session.call(openapiProvidersCustomerGetSessionRequest, {
        provider,
        requestBody: {
            launch_game_id: launchId,
            demo_mode: isDemo,
            mini_mode: isMini,
            mobile,
        },
    });

    return new Resource(async (): Promise<SessionDataType> => promise);
};
